export default __webpack_public_path__ + "./assets/product-card-model__525027f72e1e1d11d06fd958ca7d3ae3.png";